const baseColors = {
  "bg-light": "#E6EDF6",

  // Brand
  "primary-base": "#0064c5",
  "primary-light": "#e0f0ff",
  "primary-dark": "#003161",
  "primary-lightest": "#66AAF9",

  // Semantic
  "success-base": "#377C2F",
  "success-light": "#EEF8ED",
  "success-dark": "#173414",
  "error-base": "#C20E4D",
  "error-light": "#FEE7EF",
  "error-dark": "#54031E",
  "warning-base": "#FFC866",
  "warning-light": "#FEFCE8",
  "warning-dark": "#C36700",
  // Neutrals
  "neutrals-white": "#FFFFFF",
  "neutrals-lightest": "#f0f2f5",
  "neutrals-light": "#c2ccd6",
  "neutrals-base": "#a3b3c2",
  "neutrals-dark": "#668099",
  "neutrals-darkest": "#475A6B",
  "neutrals-black": "#141a1f",
  "neutrals-gray": "#52525B",

  "neutral-50": "#FAFAFA",
  "neutral-100": "#F4F4F5",
  "neutral-200": "#E4E4E7",
  "neutral-300": "#D4D4D8",
  "neutral-400": "#A1A1AA",
  "neutral-500": "#71717A",
  "neutral-600": "#52525B",
  "neutral-700": "#3F3F46",
  "neutral-800": "#27272A",
  "neutral-900": "#18181B",
  "neutral-950": "#09090b",

  "primary-50": "#e6f1fe",
  "primary-100": "#cce3fd",
  "primary-200": "#99c7fb",
  "primary-300": "#66AAF9",
  "primary-400": "#338ef7",
  "primary-500": "#006FEE",
  "primary-600": "#005bc4",
  "primary-700": "#004493",
  "primary-800": "#002e62",
  "primary-900": "#001731",

  "success-50": "#e8faf0",
  "success-100": "#d1f4e0",
  "success-200": "#a2e9c1",
  "success-300": "#74dfa2",
  "success-400": "#45d483",
  "success-500": "#17c964",
  "success-600": "#12a150",
  "success-700": "#0e793c",
  "success-800": "#095028",
  "success-900": "#052814",

  "warning-50": "#fefce8",
  "warning-100": "#fdedd3",
  "warning-200": "#fbdba7",
  "warning-300": "#ffcf66",
  "warning-400": "#f7b750",
  "warning-500": "#f5a524",
  "warning-600": "#c4841d",
  "warning-700": "#936316",
  "warning-800": "#62420e",
  "warning-900": "#312107",

  "danger-50": "#fee7ef",
  "danger-100": "#fdd0df",
  "danger-200": "#faa0bf",
  "danger-300": "#f871a0",
  "danger-400": "#f54180",
  "danger-500": "#f31260",
  "danger-600": "#c20e4d",
  "danger-700": "#920b3a",
  "danger-800": "#920b3a",
  "danger-900": "#310413",

  "cyan-500": "#7EE7FC",
};

const aliases = {
  "theme-background": baseColors["neutrals-lightest"],
};

export const colors = { ...baseColors, ...aliases };
